
import Testimonial from "@/components/Testimonial.vue";
import * as themeColors from "@assets/styles/colors.module.scss";
import { useBuilderShowIf } from "../composables/builderFieldUtility";
import { builderCta } from "@/helpers/builder-init/index";
const colors = ["None", ...Object.keys(themeColors)];
const { hasValue, hasValueEqualTo, hasRichText } = useBuilderShowIf();

export const testimonialInit = {
    component: Testimonial,
    name: "Testimonial",
    canHaveChildren: true,
    inputs: [
        {
            name: "backgroundImage",
            friendlyName: "Background Image",
            helperText: "Allowed file types - .jpeg, .png, .mp4, .gif, .svg",
            allowedFileTypes: ["jpeg", "png", "mp4", "gif", "svg"],
            type: "file"
        },
        {
            name: "mobileBackgroundImage",
            friendlyName: "Mobile Background Image",
            helperText: "Allowed file types - .jpeg, .png, .mp4, .gif, .svg",
            allowedFileTypes: ["jpeg", "png", "mp4", "gif", "svg"],
            type: "file"
        },
        {
            name: "eyebrow",
            friendlyName: 'Eyebrow',
            type: "object",
            subFields: [
                {
                    name: "text",
                    friendlyName: "Text",
                    type: "string",
                },
                {
                    name: "color",
                    friendlyName: "Color",
                    type: "string",
                    enum: colors,
                }
            ]
        },
        {
            name: "testimonialHeadline",
            friendlyName: "Testimonial Headline",
            type: "object",
            subFields: [
                {
                    name: "text",
                    friendlyName: "Text",
                    type: "string",
                },
                {
                    name: "color",
                    friendlyName: "Color",
                    type: "string",
                    enum: colors,
                }
            ]
        },
        {
            name: "testimonialName",
            friendlyName: "Testimonial Name",
            type: "object",
            subFields: [
                {
                    name: "text",
                    friendlyName: "Text",
                    type: "string",
                },
                {
                    name: "color",
                    friendlyName: "Color",
                    type: "string",
                    enum: colors,
                }
            ]
        }
    ]
}
